import React, {useEffect, useState} from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {withRouter} from 'react-router-dom';
import {Header} from 'semantic-ui-react';
import _ from 'lodash';
import {compileContent} from 'common/utils';

export const DynamicList = (props) => {
  const [dataToRender, setDataToRender] = useState([]);

  const {data, listType, header, headerSize, fieldPath, idPath} = props;
  const id = _.get(props, 'id', 'DynamicList');

  useEffect(() => {
    const {data, orderBy} = props;

    const orderedData = _.orderBy(
      _.omit(data, 'loading'),
      _.map(orderBy, (order) => order.key),
      _.map(orderBy, (order) => order.order || '')
    );

    setDataToRender(orderedData);
  }, [data]);

  const renderListElements = (dataToRender) =>
    _.map(dataToRender, (element) => {
      // Need to add Link capability in the future
      const listText = fieldPath ? _.get(element, fieldPath, '') : element;
      const listId = idPath ? _.get(element, idPath, listText) : listText;
      let listElement = listText;
      if (fieldPath == 'subGrantId') {
        listElement = (
          <a href={`/subGrant/${listText}`} target="_blank">
            {listText}
          </a>
        );
      } else if (fieldPath == 'grantId') {
        listElement = (
          <a href={`/grant/${listText}`} target="_blank">
            {listText}
          </a>
        );
      }
      return (
        <li id={`${id}-${listId}`} key={`${id}-${listId}`}>
          {listElement}
        </li>
      );
    });

  const renderList = (dataToRender) => {
    switch (listType) {
      case 'ordered':
        return <ol id={id}>{renderListElements(dataToRender)}</ol>;
      case 'unordered':
        return <ul id={id}>{renderListElements(dataToRender)}</ul>;
      default:
        // Need to add Link capability in the future
        return _.map(dataToRender, (element) => {
          const listText = fieldPath ? _.get(element, fieldPath, '') : element;
          const listId = idPath ? _.get(element, idPath, listText) : listText;
          return (
            <div id={`${id}-${listId}`} key={`${id}-${listId}`}>
              {listText}
            </div>
          );
        });
    }
  };

  return (
    <>
      <Header as={headerSize || 'h4'} content={header} id={header} />
      {renderList(dataToRender)}
    </>
  );
};

export default withRouter(connectDynamic(DynamicList));
